import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// project import
import config from 'config';
import useAuth from 'hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }) =>
{
   const { isLoggedIn } = useAuth();
   const navigate = useNavigate();

   const location = useLocation();

   useEffect(() =>
   {
      const searchParams = new URLSearchParams(location.search);
      const nextPath = searchParams.get('next');

      if (isLoggedIn)
      {
         navigate(nextPath || config.defaultPath, { replace: true });
      }
   }, [isLoggedIn, navigate, location]);

   return children;
};

GuestGuard.propTypes = {
   children: PropTypes.node
};

export default GuestGuard;
